import { WEBUILogs } from "../logging";

export default function(parsable) {
    if (!parsable) {
        WEBUILogs.error("toTinqinDateString: invalid argument.");
    } else {
        let date = new Date(parsable);
        let year = normalizeYear(date.getFullYear());
        let dayNumber = date.getDate();
        let month = date.getMonth() + 1;

        if (month < 10) {
            month = "0" + month;
        }
        if (dayNumber < 10) {
            dayNumber = "0" + dayNumber;
        }
        return year + "-" + month + "-" + dayNumber;
    }
}

function normalizeYear(year) {
    //Normalizing the year number as prescribed in ISO8601 -> from 0000 to 9999.
    if (year < 1000 && year > 99) return "0" + year;
    if (year < 100 && year > 9) return "00" + year;
    if (year < 10 && year > 0) return "000" + year;

    return year;
}
